/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/029-podcast': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 8a8 8 0 10-10.786 7.501L5 16h6l-.214-.499A8.002 8.002 0 0016 8zM7.606 9.919a1 1 0 11.788 0L8 9l-.394.919zm.804.039a2 2 0 10-.82-.001l-1.166 2.721A4.002 4.002 0 014 9.001c0-2.209 1.791-4.188 4-4.188s4 1.978 4 4.188a4 4 0 01-2.424 3.677L8.41 9.958zm2.347 5.475l-1.155-2.695A5.002 5.002 0 008 3a5 5 0 00-1.602 9.738l-1.155 2.695A6.997 6.997 0 011.003 9c0-3.865 3.133-7.185 6.997-7.185S14.997 5.135 14.997 9a7 7 0 01-4.24 6.433z"/>'
  }
})
